<template>
  <ol class="working-process">
    <li
      v-for="(step, index) in steps"
      :key="index"
      class="wp-step"
      data-aos="fade-up"
      :data-aos-delay="100 + index * 100"
    >
      <span class="wp-number">{{ String(index + 1).padStart(2, '0') }}</span>
      <span class="wp-dot" aria-hidden="true" />
      <div class="wp-body">
        <Icon v-if="step.icon" :name="step.icon" size="40" icon-class="wp-icon" />
        <h4 class="wp-title LexenSemiBold">{{ step.title }}</h4>
        <p class="wp-description">{{ step.description }}</p>
      </div>
    </li>
  </ol>
</template>

<script>
import Icon from '../../icon/Icon'

export default {
  name: 'WorkingProcess',
  components: { Icon },
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  }
}
</script>
